import ChatImage1 from "assets/images/ChatImg1.png";
import ChatImage2 from "assets/images/ChatImg2.png";
import ChatImage3 from "assets/images/ChatImg3.png";
import ChatImage4 from "assets/images/ChatImg4.png";
import ChatImage5 from "assets/images/ChatImg5.png";
import ChatImage6 from "assets/images/ChatImg6.png";
import ChatImage7 from "assets/images/ChatImg7.png";
import Review from "assets/Home/Review.svg";
import BriefcaseIcon from "assets/Home/Briefcase.svg";
import MessageIcon from "assets/icons/Message.svg";
import PropertyUsers from "assets/icons/PropertyUsers.svg";
import Property from "assets/icons/Property.svg";
import CurrencyDollar from "assets/icons/CurrencyDollar.svg";

export const messages = [
  //     {
  //       id: 0,
  //       name: "James Plumbing Co.",
  //       service: "HVAC Repair",
  //       lastMessage: "Received an offer",
  //       timestamp: "1h ago",
  //       isOnline: true,
  //       hasOffer: true,
  //       rating: 4,
  //       profileImage: ChatImage1,
  //       proposal: {
  //         title: "Proposal for: HVAC Repair",
  //         date: "Jun 15, 2025",
  //         estimatedCost: "1 Day",
  //         timeframe: "Available this Friday (Between 6 AM - 12 AM)",
  //         message: `Hi there,

  // I've handled similar HVAC issues in the area. I can complete this within a day.

  // Let me know if Friday morning works for you.
  // Regards James Plumbing Co.`,
  //         attachments: ["License.pdf", "Insurance - certificate.png"],
  //       },
  //     },
  {
    id: 0,
    name: "James Plumbing Co.",
    service: "HVAC Repair",
    lastMessage: "JOB ACCEPTED",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    hasJob: true,
    rating: 4,
    profileImage: ChatImage1,
    proposal: {
      title: "Job: HVAC Repair",
      date: "Date: Jun 15, 2025",
      estimatedCost: "TBD",
      timeframe: " Friday Morning 8 AM - 12 PM",
      message: `_____________ has accepted your job at the above referenced time frame. You may now communicate with the service provider here.`,
    },
    chatMessages: [
      {
        sender: "you",
        time: "8:22 PM",
        message: "Hello, I’ll be there. What do you need access to?",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message: "Hi! Yes — I’m available between 9:00 AM and 11:30 AM.",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message: "Will someone be on-site to let us in?",
      },
    ],
  },
  {
    id: 1,
    name: "AquaFix Services",
    service: "Faucet Replacement",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 5,
    profileImage: ChatImage2,
    chatMessages: [
      {
        sender: "them",
        time: "8:24 PM",
        message: "Hi! Yes - I'm available between 9:00 AM and 11:30 AM.",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message: "Will someone be on-site to let us in?",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message:
          "Just the HVAC unit and utility closet. Also - any parking restrictions we should know about?",
      },
      {
        sender: "you",
        time: "8:22 PM",
        message: "Hi James, thanks for the quote.",
      },
      {
        sender: "you",
        time: "8:25 PM",
        message: "Yes, I'll be there. What do you need access to?",
      },
    ],
  },
  {
    id: 2,
    name: "James Bobby",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage3,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 3,
    name: "James Plumbing Co.",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage4,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 4,
    name: "AquaFix Services",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage5,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 5,
    name: "James Bobby",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage6,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 6,
    name: "James Plumbing Co.",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage7,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 7,
    name: "AquaFix Services",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage5,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 8,
    name: "James Bobby",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage6,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
  {
    id: 9,
    name: "James Plumbing Co.",
    service: "HVAC Repair",
    lastMessage: "You: Can you send a photo?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage7,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
];
export const newMessages = [
  {
    id: 0,
    name: "James Plumbing Co.",
    service: "HVAC Repair",
    lastMessage:
      "Just the HVAC unit and utility closet. Also — any parking restrictions we should know about?",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 4,
    profileImage: ChatImage1,
    chatMessages: [
      {
        sender: "them",
        time: "8:24 PM",
        message: "Hi! Yes - I'm available between 9:00 AM and 11:30 AM.",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message: "Will someone be on-site to let us in?",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message:
          "Just the HVAC unit and utility closet. Also - any parking restrictions we should know about?",
      },
      {
        sender: "you",
        time: "8:22 PM",
        message: "Hi James, thanks for the quote.",
      },
      {
        sender: "you",
        time: "8:25 PM",
        message: "Yes, I'll be there. What do you need access to?",
      },
    ],
  },
  {
    id: 1,
    name: "Jason Green",
    service: "Tenant",
    lastMessage: "Its freezing in here",
    timestamp: "1h ago",
    isOnline: true,
    hasOffer: false,
    rating: 5,
    profileImage: ChatImage2,
    chatMessages: [
      {
        sender: "them",
        time: "8:24 PM",
        message: "Hi! Yes - I'm available between 9:00 AM and 11:30 AM.",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message: "Will someone be on-site to let us in?",
      },
      {
        sender: "them",
        time: "8:24 PM",
        message:
          "Just the HVAC unit and utility closet. Also - any parking restrictions we should know about?",
      },
      {
        sender: "you",
        time: "8:22 PM",
        message: "Hi James, thanks for the quote.",
      },
      {
        sender: "you",
        time: "8:25 PM",
        message: "Yes, I'll be there. What do you need access to?",
      },
    ],
  },
  {
    id: 2,
    name: "James Bobby",
    service: "HVAC Repair",
    lastMessage: "I cant get a good photo of it",
    timestamp: "2h ago",
    isOnline: true,
    hasOffer: false,
    rating: 3,
    profileImage: ChatImage3,
    chatMessages: [
      {
        sender: "you",
        time: "7:30 PM",
        message: "Can you send a photo of the electrical panel?",
      },
      {
        sender: "them",
        time: "7:45 PM",
        message: "Sure, I'll send it over in a few minutes.",
      },
    ],
  },
];
export const pastJobs = [
  {
    id: 1,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Completed",
  },
  {
    id: 2,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "123 Oak Street, Austin, TX",
    date: "12/15/2024",

    status: "Cancelled",
  },
  {
    id: 3,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Completed",
  },
  {
    id: 4,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "123 Oak Street, Austin, TX",
    date: "12/15/2024",

    status: "Cancelled",
  },
  {
    id: 5,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Completed",
  },
  {
    id: 6,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Completed",
  },
];
export const activeJobs = [
  {
    id: 1,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Assigning Vendor",
  },
  {
    id: 2,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "123 Oak Street, Austin, TX",
    date: "12/15/2024",

    status: "In Progress",
  },
  {
    id: 3,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Assigning Vendor",
  },
  {
    id: 4,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "123 Oak Street, Austin, TX",
    date: "12/15/2024",

    status: "Assigning Vendor",
  },
  {
    id: 5,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Assigning Vendor",
  },
  {
    id: 6,
    title: "Kitchen Faucet Repair",
    jobId: "Job Number",
    address: "Property Address",
    date: "Date Job was created",

    status: "Assigning Vendor",
  },
];
export const cardsProfessionals = ({
  statistics,
  unreadCount = 0,
  userData = {},
}) => {
  const defaultPm = Array.isArray(userData?.paymentMethods)
    ? userData.paymentMethods.find((pm) => pm.isDefault)
    : null;
  const pmHeader = defaultPm
    ? defaultPm.brand.charAt(0).toUpperCase() + defaultPm.brand.slice(1)
    : "Manage";
  const pmSubtext = defaultPm ? `•••• ${defaultPm.last4}` : "Payment Method";

  return {
    LANDLORD: [
      {
        icon: Property,
        title: "Properties",
        number: statistics?.totalProperties,
        value: "properties",
      },
      {
        icon: PropertyUsers,
        title: "Pending Approvals",
        number: statistics?.pendingApprovals,
        value: "pendingApprovals",
      },
      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
      {
        icon: CurrencyDollar,
        title: pmSubtext,
        number: pmHeader,
        value: "paymentMethods",
        isDefault: !!defaultPm,
      },
    ],
    PROPERTY_MANAGER: [
      {
        icon: Property,
        title: "Properties",
        number: statistics?.totalProperties,
        value: "properties",
      },
      {
        icon: PropertyUsers,
        title: "Pending Approvals",
        number: statistics?.pendingApprovals,
        value: "pendingApprovals",
      },
      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
      {
        icon: CurrencyDollar,
        title: pmSubtext,
        number: pmHeader,
        value: "paymentMethods",
        isDefault: !!defaultPm,
      },
    ],
    HOMEOWNER: [
      {
        icon: Property,
        title: "Properties",
        number: statistics?.totalProperties,
        value: "properties",
      },

      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
      {
        icon: CurrencyDollar,
        title: pmSubtext,
        number: pmHeader,
        value: "paymentMethods",
        isDefault: !!defaultPm,
      },
    ],
    STR_HOST: [
      {
        icon: Property,
        title: "Properties",
        number: statistics?.totalProperties,
        value: "properties",
      },
      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
      {
        icon: CurrencyDollar,
        title: pmSubtext,
        number: pmHeader,
        value: "paymentMethods",
        isDefault: !!defaultPm,
      },
    ],
    FAMILY_MEMBER: [
      {
        icon: Property,
        title: "Properties",
        number: statistics?.totalProperties,
        value: "properties",
      },

      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
    ],
    TENANT: [
      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },
      {
        icon: BriefcaseIcon,
        title: "Past Jobs",
        number: statistics?.pastJobs,
        value: "pastJobs",
      },

      {
        icon: MessageIcon,
        title: "Unread Messages",
        number: unreadCount,
        value: "unreadMessages",
      },
    ],
    VENDOR: [
      {
        icon: BriefcaseIcon,
        title: "Available Jobs",
        number: statistics?.availableJobs,
        value: "availableJobs",
      },

      {
        icon: Review,
        title: "Active Jobs ",
        number: statistics?.activeJobs,
        value: "activeJobs",
      },

      {
        icon: BriefcaseIcon,
        title: "Open Invoices",
        number: statistics?.openInvoices,
        value: "openInvoices",
      },
      {
        icon: BriefcaseIcon,
        title: "Paid Invoices",
        number:
          statistics?.paidInvoices ??
          statistics?.paid_invoices ??
          statistics?.paidInvoicesCount ??
          statistics?.paid_invoices_count ??
          (statistics?.invoiceCounts && statistics?.invoiceCounts?.paid) ??
          (statistics?.invoice_counts && statistics?.invoice_counts?.paid) ??
          (statistics?.invoices && statistics?.invoices?.paid) ??
          0,
        value: "paidInvoices",
      },
      {
        icon: MessageIcon,
        title: "New Messages",
        number: unreadCount,
        value: "messages",
      },
    ],
  };
};
export const pendingApprovalHeaders = [
  "Date Requested",
  "JOB NUMBER",
  "PROPERTY ADDRESS",
  "JOB TITLE",
  "VIEW DETAILS",
  "APPROVE",
];
export const pendingApprovalRows = [
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "122 Alberta Drive, Unit 3F",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
  {
    id: "010000123",
    dateRequested: "Dec 15, 2024",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    status: "Pending",
  },
];
export const invoiceHeaders = [
  "DATE ISSUED",
  "INVOICE ID",
  "AMOUNT",
  "PROPERTY ADDRESS",
  "JOB TITLE",
  "VENDOR",
  "WARRANTY SERVICE",
  "PAY NOW",
  "VIEW",
  "DOWNLOAD",
];
export const invoicePaidHeaders = [
  "DATE ISSUED",
  "INVOICE ID",
  "AMOUNT",
  "PROPERTY ADDRESS",
  "JOB TITLE",
  "VENDOR",
  "PAY NOW",
  "VIEW",
  "DOWNLOAD",
];
export const invoiceRows = [
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
  {
    dateIssued: "Dec 15, 2024",
    invoiceId: "010000123",
    amount: "$250.00",
    propertyAddress: "123 Main Street",
    jobTitle: "HVAC Repair",
    vendor: "James Plumbing Co.",
  },
];
export const roledescriptions = {
  LANDLORD: {
    welcomeMessage: {
      properties: "Here's what's happening with your properties.",
      pendingApprovals: "Here's what's happening with your properties.",
      activeJobs: "Here's what's happening with your properties.",
      pastJobs: "Here's what's happening with your properties.",
      openInvoices: "Here's what's happening with your properties.",
      messages: "Here's what's happening with your properties.",
    },
    description:
      "All the properties you manage in one place. Add new addresses, edit existing ones, and monitor job activity by property.",
  },
  PROPERTY_MANAGER: {
    welcomeMessage: {
      properties: "Here's what's happening with your properties.",
      pendingApprovals: "Here's what's happening with your properties.",
      activeJobs: "Here's what's happening with your properties.",
      pastJobs: "Here's what's happening with your properties.",
      openInvoices: "Here's what's happening with your properties.",
      messages: "Here's what's happening with your properties.",
    },
    description:
      "All the properties you manage in one place. Add new addresses, edit existing ones, and monitor job activity by property.",
  },
  HOMEOWNER: {
    welcomeMessage: {
      properties: "Here's what's happening with your properties.",
      activeJobs: "Here's what's happening with your properties.",
      pastJobs: "Here's what's happening with your properties.",
      openInvoices: "Here's what's happening with your properties.",
      messages: "Here's what's happening with your properties.",
    },
  },
  STR_HOST: {
    welcomeMessage: {
      properties: "Here's what's happening with your properties.",
      activeJobs: "Here's what's happening with your properties.",
      pastJobs: "Here's what's happening with your properties.",
      openInvoices: "Here's what's happening with your properties.",
      messages: "Here's what's happening with your properties.",
    },
  },
  FAMILY_MEMBER: {
    welcomeMessage: {
      properties: "Here's what's happening with your properties.",
      activeJobs: "Here's what's happening with your properties.",
      pastJobs: "Here's what's happening with your properties.",
      openInvoices: "Here's what's happening with your properties.",
      messages: "Here's what's happening with your properties.",
    },
    description:
      "All the properties you manage in one place. Add new addresses, edit existing ones, and monitor job activity by property.",
  },
  TENANT: {
    welcomeMessage: {
      activeJobs: "Here's what's happening with your home.",
      pastJobs: "Here's what's happening with your unit.",
      messages: "Here's what's happening with your unit.",
    },
  },
  VENDOR: {
    welcomeMessage: {
      availableJobs: "Here's what's happening with your jobs today.",
      activeJobs: "Here's what's happening with your jobs today.",
      openInvoices: "Here's what's happening with your jobs today.",
      paidInvoices: "Here's what's happening with your jobs today.",
      messages: "Here's what's happening with your jobs today.",
    },

    paidInvoices: "View, download, and manage all paid invoices for your jobs.",
    openInvoices: "View, download, and manage all open invoices for your jobs.",
  },
};
export const searchbarVisibilty = {
  LANDLORD: {
    properties: true,
    pendingApprovals: true,
    activeJobs: false,
    pastJobs: true,
    openInvoices: true,
    mainOpenInvoices: false,
    mainPaidInvoices: true,
  },
  PROPERTY_MANAGER: {
    properties: true,
    pendingApprovals: true,
    activeJobs: false,
    pastJobs: true,
    openInvoices: true,
    mainOpenInvoices: false,
    mainPaidInvoices: true,
  },
  HOMEOWNER: {
    activeJobs: false,
    pastJobs: false,
    openInvoices: false,
    mainOpenInvoices: false,
    mainPaidInvoices: true,
  },
  STR_HOST: {
    activeJobs: false,
    pastJobs: false,
    openInvoices: false,
    mainOpenInvoices: false,
    mainPaidInvoices: true,
  },
  FAMILY_MEMBER: {
    properties: true,
    pendingApprovals: true,
    activeJobs: false,
    pastJobs: true,
    openInvoices: true,
    mainOpenInvoices: false,
    mainPaidInvoices: true,
  },
  TENANT: {
    activeJobs: false,
    pastJobs: false,
  },
  VENDOR: {
    availableJobs: false,
    activeJobs: false,
    openInvoices: false,
    paidInvoices: true,
    mainOpenInvoices: true,
    mainPaidInvoices: true,
  },
};
export const headers = {
  pendingApprovals: [
    "Date Requested",
    "JOB NUMBER",
    "PROPERTY ADDRESS",
    "JOB TITLE",
    "VIEW DETAILS",
    "APPROVE",
  ],
  openInvoices: [
    "DATE ISSUED",
    "INVOICE ID",
    "AMOUNT",
    "PROPERTY ADDRESS",
    "JOB TITLE",
    "VENDOR",
    "JOB DESCRIPTION",
    "WARRANTY SERVICE",
    "VIEW",
    // "PAY NOW",
    // "DOWNLOAD",
  ],
  paidInvoices: [
    "DATE ISSUED",
    "INVOICE ID",
    "AMOUNT",
    "PROPERTY ADDRESS",
    "JOB TITLE",
    "VENDOR",
    "JOB DESCRIPTION",
    "DATE PAID",
    "WARRANTY SERVICE",
    "VIEW",
    // "DOWNLOAD",
  ],
  availableJobs: [
    "DATE ISSUED",
    "TIME ISSUED",
    "ORIGINAL ESTIMATE RANGE",
    "LOCATION",
    "JOB CATEGORY",
    "JOB TYPE",
    "JOB DESCRIPTION",
    "VIEW DETAILS TO ACCEPT",
  ],
};
export const tableData = {
  pendingApprovals: [
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "122 Alberta Drive, Unit 3F",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
    {
      id: "010000123",
      dateRequested: "Dec 15, 2024",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      status: "Pending",
    },
  ],

  openInvoices: [
    {
      dateIssued: "Dec 15, 2024",
      invoiceId: "010000123",
      amount: "$250.00",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      vendor: "James Plumbing Co.",
      jobDescription: "Faucet has a Steady Drip",
    },
    {
      dateIssued: "Dec 15, 2024",
      invoiceId: "010000124",
      amount: "$300.00",
      propertyAddress: "456 Oak Avenue",
      jobTitle: "Plumbing Repair",
      vendor: "AquaFix Services",
      jobDescription: "Kitchen sink is clogged",
    },
    {
      dateIssued: "Dec 14, 2024",
      invoiceId: "010000125",
      amount: "$400.00",
      propertyAddress: "789 Pine Street",
      jobTitle: "Electrical Work",
      vendor: "PowerPro Electric",
      jobDescription: "Outlets not working properly",
    },
  ],
  paidInvoices: [
    {
      dateIssued: "Dec 15, 2024",
      invoiceId: "010000123",
      amount: "$250.00",
      propertyAddress: "123 Main Street",
      jobTitle: "HVAC Repair",
      vendor: "James Plumbing Co.",
      jobDescription: "Faucet has a Steady Drip",
      datePaid: "Dec 17, 2024",
    },
    {
      dateIssued: "Dec 14, 2024",
      invoiceId: "010000124",
      amount: "$300.00",
      propertyAddress: "456 Oak Avenue",
      jobTitle: "Plumbing Repair",
      vendor: "AquaFix Services",
      jobDescription: "Kitchen sink is clogged",
      datePaid: "Dec 16, 2024",
    },
    {
      dateIssued: "Dec 13, 2024",
      invoiceId: "010000125",
      amount: "$400.00",
      propertyAddress: "789 Pine Street",
      jobTitle: "Electrical Work",
      vendor: "PowerPro Electric",
      jobDescription: "Outlets not working properly",
      datePaid: "Dec 15, 2024",
    },
  ],

  availableJobs: [
    {
      dateIssued: "Dec 15, 2024",
      timeIssued: "9:30 AM",
      estimatedRange: "$200-300",
      location: "Town",
      jobTitle: "Animal Trapping",
      jobDescription:
        "I am hearing an animal in the attic. Not sure what it is",
    },
    {
      dateIssued: "Dec 14, 2024",
      timeIssued: "2:15 PM",
      estimatedRange: "$150-250",
      location: "Downtown",
      jobTitle: "Plumbing Repair",
      jobDescription: "Kitchen sink is clogged and water is backing up",
    },
    {
      dateIssued: "Dec 13, 2024",
      timeIssued: "11:45 AM",
      estimatedRange: "$300-500",
      location: "Suburbs",
      jobTitle: "HVAC Maintenance",
      jobDescription: "AC unit making strange noises and not cooling properly",
    },
    {
      dateIssued: "Dec 12, 2024",
      timeIssued: "4:20 PM",
      estimatedRange: "$100-200",
      location: "City Center",
      jobTitle: "Electrical Work",
      jobDescription: "Outlets in living room not working, need inspection",
    },
    {
      dateIssued: "Dec 11, 2024",
      timeIssued: "8:00 AM",
      estimatedRange: "$400-600",
      location: "West Side",
      jobTitle: "Roof Repair",
      jobDescription: "Small leak in roof after recent storm, needs patching",
    },
  ],
};
export const ModalTitles = { jobDeatails: "Job Details" };
